var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .funnel-cls-1 {\n        fill: #d0d6dc;\n      }\n\n      .funnel-cls-2 {\n        fill: none;\n        opacity: .2;\n      }\n\n      .funnel-cls-3 {\n        fill: #c2c8cc;\n      }\n\n      .funnel-cls-4 {\n        fill: #b0b7bf;\n      }\n\n      .funnel-cls-5 {\n        fill: #b7bfc4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2-2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "funnel-cls-2",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "deep-fill",
    className: "funnel-cls-5",
    points: "9.25 16.76 14.75 16.76 17.5 12 6.5 12 9.25 16.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "deep-fill-2",
    className: "funnel-cls-4",
    points: "12 21.53 14.75 16.76 9.25 16.76 12 21.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "bright-fill",
    className: "funnel-cls-3",
    points: "3.75 7.24 6.5 12 17.5 12 20.25 7.24 3.75 7.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "bright-fill-2",
    className: "funnel-cls-1",
    points: "23 2.47 1 2.47 3.75 7.24 20.25 7.24 23 2.47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.126f816955908a8eccdba3201e17b312.svg";
export { ForwardRef as ReactComponent };